import { EventApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY, ORGANIZATIONS_KEY } from './keys';

function usePutOrganizations() {
  const queryClient = useQueryClient();

  return useAuthMutation(EventApi.putOrganizations, {
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).detail(String(variables.id || '')),
      });
      queryClient.invalidateQueries({
        queryKey: getQueryKeys(ORGANIZATIONS_KEY).detail(variables.id),
      });
    },
  });
}

export default usePutOrganizations;
